var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('base-stack',{attrs:{"direction":"row","align":"center"}},[_c('label',{staticClass:"toggle-switch"},[_c('input',{attrs:{"type":"checkbox","disabled":_vm.disabled},domProps:{"checked":_vm.value},on:{"change":_vm.handleChange}}),_c('span',{staticClass:"slider"})]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }